import { RestClient } from '@libs/rest-client';
import {
  hoMstDelete,
  hoMstExport,
  hoMstFetch,
  hoMstImport,
  hoMstListRequest,
  hoMstRegistration,
  hoMstUpdate,
} from '@libs/templates/mst';
import {
  LeaseCompanyMstListSearchRaw,
  LeaseCompanyMstRegistration,
  LeaseCompanyMstRegistrationRaw,
  LeaseCompanyMstSetting,
  LeaseCompanyMstSettingRaw,
} from '../models';

const LEASE_COMPANY_MST_URL = '/la-company-mst';

const register = hoMstRegistration(LEASE_COMPANY_MST_URL, LeaseCompanyMstRegistrationRaw)();

const listRequest = hoMstListRequest(
  LEASE_COMPANY_MST_URL,
  LeaseCompanyMstListSearchRaw,
  LeaseCompanyMstRegistration,
)();

const doExport = hoMstExport(LEASE_COMPANY_MST_URL, LeaseCompanyMstListSearchRaw)();

const fetchMst = hoMstFetch(LEASE_COMPANY_MST_URL, LeaseCompanyMstRegistration)();

const update = hoMstUpdate(LEASE_COMPANY_MST_URL, LeaseCompanyMstRegistrationRaw)();

const remove = hoMstDelete(LEASE_COMPANY_MST_URL)();

const importFunction = hoMstImport(LEASE_COMPANY_MST_URL)();

async function fetchSetting() {
  return LeaseCompanyMstSetting.fromRaw(
    await RestClient.fa.get<LeaseCompanyMstSettingRaw>(`${LEASE_COMPANY_MST_URL}/setting`),
  );
}

async function registerSetting(setting: LeaseCompanyMstSetting) {
  await RestClient.fa.put(`${LEASE_COMPANY_MST_URL}/setting`, LeaseCompanyMstSettingRaw.fromModel(setting));
}

export {
  doExport,
  fetchMst,
  fetchSetting,
  importFunction,
  listRequest,
  register,
  registerSetting,
  remove,
  update,
};
